import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1acf21e9: FaireBrandEntity = {
  token: "b_1acf21e9",
  type: "brand",
  name: "babysoy Inc",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a5b18d18ec565ba5e520150dc6db527850f5baae844571795660d212ed7aec5e/1554501212.png",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/41954efdac453b0a94c03aa8eca6606cf89d225b63041f3a55e3ca6a9d32f9b5/1554501436.png",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a5b18d18ec565ba5e520150dc6db527850f5baae844571795660d212ed7aec5e/1554501212.png",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/41954efdac453b0a94c03aa8eca6606cf89d225b63041f3a55e3ca6a9d32f9b5/1554501436.png",
  location: "Chino Hills, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 252,
  isInsider: true,
  description:
    "Babysoy was founded in 2005 with a mission to provide affordable baby layettes made with sustainable and/or organic fabrics.  For over a decade now, we have earned a reputation for providing quality clothes at a reasonable price.   As our journey continues, we invite you to learn more about Babysoy's soft and comfy baby gowns, sleepers, bodysuits, pants, blankets, bibs, socks, & hats made with azlon from soy protein fiber.  Covering babies and toddlers from head to toe with sustainable layette and accessories!  We are the first company to use Azlon from Soy Protein fabric to make baby clothes.  Azlon from soy is a sustainable fabric using the leftover pulp of soy milk production, it has a porous structure to allow more moisture transmission to keep the wearer dry and warm.  Since most of our products are made with soy-based fabric, it has a soy-creamy base color, so we don't have any white colors. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:55.647Z",
    importedBy: "entity-db-cli",
  },
};
